export default "__VITE_ASSET__3kO7Q_4N__"